<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :height="Number(size ?? 20) * (iconObject.width / iconObject.height)"
    :viewBox="iconObject.viewBox"
    :width="size ?? 20"
    :fill="color ?? 'currentColor'"
  >
    <path :d="iconObject.path" color="" />
  </svg>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import gscIconSet from "./icons";

const props = defineProps<{
  icon: keyof typeof gscIconSet;
  size?: number | string;
  color?: string;
}>();

const iconObject = gscIconSet[props.icon];
</script>
